import { gaPush } from '../configuration/setup/googleAnalytics';
import { Criticality } from '../features/warnings/utils/types';

const AnalyticsEvents = {
    filterApplyVehicleDiagnostic: (elementState: Criticality) => {
        gaPush({
            event: 'selected_warning_status_filter',
            parameters: {
                component_name: 'StatWidget',
                flow_name: 'vehicle_diagnostic',
                element_name: 'WarningWrapper',
                trigger: 'click',
                element_state: elementState,
            },
            userProps: {},
        });
    },
    filterApplyWearTearRepairWarnings: (elementState: Criticality) => {
        gaPush({
            event: 'selected_warning_status_filter',
            parameters: {
                component_name: 'StatWidget',
                flow_name: 'wear_tear_repair_warnings',
                element_name: 'WarningWrapper',
                trigger: 'click',
                element_state: elementState,
            },
            userProps: {},
        });
    },
    filterRemoveVehicleDiagnostic: (elementState: Criticality) => {
        gaPush({
            event: 'reverted_warning_status_filter',
            parameters: {
                component_name: 'StatWidget',
                flow_name: 'vehicle_diagnostic',
                element_name: 'WarningWrapper',
                trigger: 'click',
                element_state: elementState,
            },
            userProps: {},
        });
    },
    filterRemoveWearTearRepairWarnings: (elementState: Criticality) => {
        gaPush({
            event: 'reverted_warning_status_filter',
            parameters: {
                component_name: 'StatWidget',
                flow_name: 'wear_tear_repair_warnings',
                element_name: 'WarningWrapper',
                trigger: 'click',
                element_state: elementState,
            },
            userProps: {},
        });
    },
    filterResetWearTearRepairWarnings: () => {
        gaPush({
            event: 'reverted_warning_status_filter',
            parameters: {
                component_name: 'StatWidget',
                flow_name: 'wear_tear_repair_warnings',
                element_name: 'WarningWrapper',
                trigger: 'click',
                element_state: 'Revert',
            },
            userProps: {},
        });
    },
    filterResetVehicleDiagnostic: () => {
        gaPush({
            event: 'reverted_warning_status_filter',
            parameters: {
                component_name: 'StatWidget',
                flow_name: 'vehicle_diagnostic',
                element_name: 'WarningWrapper',
                trigger: 'click',
                element_state: 'Reset',
            },
            userProps: {},
        });
    },
    sectionViewVehicleDiagnosticRepairWarnings: (elementState: string = 'no_data') => {
        gaPush({
            event: 'section_view',
            parameters: {
                component_name: 'Sidebar',
                flow_name: 'vehicle_diagnostic',
                element_name: 'WarningWrapper',
                trigger: 'visibility',
                element_state: elementState,
            },
            userProps: {},
        });
    },
    viewAllRepairVehicleDiagnostic: () => {
        gaPush({
            event: 'open_view_all_warnings',
            parameters: {
                component_name: 'Button',
                flow_name: 'vehicle_diagnostic',
                element_name: 'repair_warnings',
                trigger: 'click',
            },
            userProps: {},
        });
    },
    viewAllRepairWearTearRepairWarnings: () => {
        gaPush({
            event: 'open_view_all_warnings',
            parameters: {
                component_name: 'Button',
                flow_name: 'wear_tear_repair_warnings',
                element_name: 'repair_warnings',
                trigger: 'click',
            },
            userProps: {},
        });
    },
    expandStatusMeaning: () => {
        gaPush({
            event: 'expand_status_meaning',
            parameters: {
                component_name: 'Button',
                flow_name: 'vehicle_diagnostic',
                element_name: 'repair_warnings',
                trigger: 'click',
            },
            userProps: {},
        });
    },
};

export default AnalyticsEvents;
